import React from 'react'
import { contentId } from '../../utils/contentful'
import { EVEntry } from './react'

export const moduleEntity = (mod, extraData = {}) => {
  const props = { id: contentId(mod), entityId: contentId(mod), ...extraData }
  return props || {}
}

export const ContentfulModule = (props) => {
  // eslint-disable-next-line no-console
  console.log('LEGACY modules ContentfulModule', props)
  return <EVEntry {...props.entity} />
}

export const ContentfulModules = ({ modules = [] }) => {
  if (!Array.isArray(modules)) return null
  return (
    <For each='mod' of={modules} index='idx'>
      <EVEntry {...mod} key={idx} />
    </For>
  )
}
